<template>
  <div>
    <v-expansion-panel popout>
      <v-expansion-panel-content
        v-for="(item, i) in 3"
        :key="i"
      >
        <template v-slot:header>
          <div v-if="item == 1">
            {{ $t('generalConfiguration.smtpConfigurationInfo') }}
          </div>
          <div v-else-if="item == 2 && smtpUsePrivate && hasSmtpProjectAlready()">
            {{ $t('generalConfiguration.emailConfiguration') }}
          </div>
          <div v-else-if="!forConasi && smtpUsePrivate && hasSmtpProjectAlready()">
            {{ $t('generalConfiguration.mailGatewayConfig') }}
          </div>
        </template>
        <template>
          <div v-if="item == 1">
            <v-container grid-list-xl>
              <v-form
                ref="form"
                lazy-validation>
                <v-layout
                  wrap
                  layout
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-checkbox
                      v-model="smtpUsePrivate"
                      :label="$t('customization.usedPrivateSmtp')"
                      :disabled="isEntityDisabled()"
                      @change="usedEmailSystemChange"
                    />
                  </v-flex>
                  <v-flex
                    v-if="isAdmin() && smtpUsePrivate"
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="smtp_project.project_name"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.name')"
                    />
                  </v-flex>
                  <v-flex
                    v-if="smtpUsePrivate"
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="smtp_project.sender_alias"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.sender_alias')"
                    />
                  </v-flex>
                  <v-flex
                    v-if="isAdmin() && smtpUsePrivate"
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="smtp_project.description"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.description')"
                    />
                  </v-flex>
                  <v-flex
                    v-if="smtpUsePrivate"
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="smtp_project.page_size"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.pageSize')"
                    />
                  </v-flex>
                  <v-flex
                    v-if="smtpUsePrivate"
                    xs12
                    sm6
                    md6
                  >
                    <v-textarea
                      v-model="smtp_project.sub_content"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.subContent')"
                    />
                  </v-flex>
                </v-layout>
                <v-spacer/>
                <v-btn
                  v-if="smtpUsePrivate"
                  :loading="isLoading"
                  :disabled="isEntityDisabled()"
                  color="success darken-1"
                  small
                  class="pull-right"
                  @click="saveSMTPProject"
                >{{ $t('common.save') }}</v-btn>
              </v-form>
            </v-container>
          </div>
          <div v-else-if="item == 2">
            <v-container
              v-if="(smtpUsePrivate && hasSmtpProjectAlready())"
              grid-list-xl>
              <v-form
                ref="form"
                lazy-validation>
                <v-layout
                  wrap
                  layout
                >
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      :rules="[ruleValidUrlPath]"
                      v-model="smtp_email.smtp_domain"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.serverSMTP')"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      :rules="[ruleRequiredValue]"
                      v-model="smtp_email.smtp_port"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.smtp_port')"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      :rules="[ruleValidEmail]"
                      v-model="smtp_email.smtp_sender"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.emailAccount')"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-checkbox
                      :label="$t('generalConfiguration.useTLS')"
                      :disabled="isEntityDisabled()"
                      v-model="smtp_email.smtp_use_tls"/>
                  </v-flex>
                </v-layout>
                <v-spacer/>
                <v-btn
                  :loading="isLoading"
                  :disabled="isEntityDisabled()"
                  color="success darken-1"
                  small
                  class="pull-right"
                  @click="saveSMTPEmailServer"
                >{{ $t('common.save') }}</v-btn>
                <v-btn
                  :loading="isLoading"
                  :disabled="isEntityDisabled()"
                  color="warning darken-1"
                  small
                  class="pull-right"
                  @click="onShowModalChangePasswordSystemConfig()"
                >{{ $t('common.changePassword') }}</v-btn>
                <v-btn
                  :loading="isLoading"
                  :disabled="isEntityDisabled()"
                  color="info darken-1"
                  small
                  class="pull-right"
                  @click="sendTestEmail"
                >{{ $t('generalConfiguration.sendTestEmail') }}</v-btn>
              </v-form>
            </v-container>
          </div>
          <div v-else-if="!forConasi">
            <v-container
              v-if="(smtpUsePrivate && hasSmtpProjectAlready())"
              grid-list-xl>
              <v-form>
                <v-layout
                  wrap
                  layout
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-text-field
                      :rules="[ruleValidUrlPath]"
                      v-model="mailGateway.baseUrl"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.mailGatewayURL')"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-text-field
                      v-model="mailGateway.apikey"
                      :disabled="isEntityDisabled()"
                      :label="$t('generalConfiguration.mailGatewayApikey')"
                      type="password"
                    />
                  </v-flex>
                </v-layout>
                <v-spacer/>
                <v-btn
                  :loading="isLoading"
                  :disabled="isEntityDisabled()"
                  small
                  color="success darken-1"
                  class="pull-right"
                  @click="saveMailGatewayConfiguration"
                >{{ $t('common.save') }}</v-btn>
              </v-form>
            </v-container>
          </div>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <loading-bar :is-loading="isLoading" />
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
    <changeServicePasswordModal
      ref="changeServicePasswordModal"
      @updatePasswordSMTPEmail="onUpdatePasswordSMTPEmail"/>
    <sendTestEmail
      ref="sendTestEmail"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import functionUtils from 'utils/functionUtils'
import ToastType from 'enum/toastType'
import validationRules from 'utils/validationRules'
import ChangeServicePasswordModal from './ChangeServicePasswordModal'
import SendTestEmail from './SendTestEmail'
import ServiceType from 'enum/serviceType'
import { FOR_CONASI_TARGET } from 'utils/constants'
export default {
  components: {
    ChangeServicePasswordModal,
    SendTestEmail
  },
  props: {
    entityId: { type: Number, default: () => null }
  },
  data: () => ({
    smtp_email: {
      smtp_domain: null,
      smtp_sender: null,
      smtp_port: null,
      smtp_use_tls: true,
      smtp_password: null
    },
    smtp_project: {
      project_name: null,
      sender_alias: null,
      sub_content: null,
      page_size: 10,
      description: null
    },
    mailGateway: {
      baseUrl: null,
      apikey: null
    },
    smtpProjectId: null,
    smtpUsePrivate: false,
    forConasi: FOR_CONASI_TARGET,
    isLoading: false
  }),
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR',
      'GET_CURRENT_ACCOUNT'
    ])
  },
  watch: {
    entityId () {
      this.getEntitySmtpConfig()
      this.getSMTPProject()
      this.getSMTPEmailServer()
      if (!FOR_CONASI_TARGET) {
        this.getMailGatewayConfiguration()
      }
    }
  },
  created () {
    this.getEntitySmtpConfig()
    this.getSMTPProject()
    this.getSMTPEmailServer()
    if (!FOR_CONASI_TARGET) {
      this.getMailGatewayConfiguration()
    }
  },
  methods: {
    ruleRequiredValue (value) {
      return validationRules.ruleRequiredValue(value)
    },
    ruleValidEmail (value) {
      return validationRules.ruleValidEmailFormat(value)
    },
    ruleValidUrlPath (value) {
      return validationRules.ruleValidUrlPath(value)
    },
    isAdmin: function () {
      return functionUtils.isAdmin(this.GET_CURRENT_ACCOUNT)
    },
    isEntityDisabled: function () {
      return functionUtils.isCurrentEntityLocked() || functionUtils.isCurrentEntityExpired()
    },
    onShowModalChangePasswordSystemConfig: function () {
      this.$refs.changeServicePasswordModal.onShowModal(ServiceType.EMAIL_SMTP)
    },
    getEntitySmtpConfig: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
      }
      this.GET_ENTITY_SMTP_CONFIGURATION({ id: entityId }).then(
        function (res) {
          let data = res.data
          this.smtpUsePrivate = data.smtp_use_private
          this.smtpProjectId = data.smtp_project_id
        }.bind(this)
      )
    },
    onUpdatePasswordSMTPEmail: function (password) {
      this.smtp_email.smtp_password = password
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
      }
      let data = {
        smtp_password: this.smtp_email.smtp_password,
        entity_id: entityId
      }
      this.PUSH_SMTP_EMAIL_PASSWORD(data).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
        }.bind(this)
      ).catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    /**
     * Used email system change
     */
    usedEmailSystemChange: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        if (this.isEntityDisabled()) {
          return // Locked or expired entity will not able to perform these actions
        }
        entityId = sessionStorage.getItem('entityId')
      }
      let filter = {
        entityId: entityId,
        usePrivateSmtp: this.smtpUsePrivate
      }
      this.SET_USE_PRIVATE_SMTP(filter).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
        }.bind(this)
      ).catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    hasSmtpProjectAlready: function () {
      return (!functionUtils.isNull(this.smtpProjectId) && this.smtpProjectId !== 'null' && this.smtpProjectId !== 'undefined')
    },
    /**
     * Get SMTP project
     */
    getSMTPProject: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
      }
      let filter = {
        params: {
          entityId: entityId
        }
      }
      this.GET_SMTP_PROJECT(filter).then(
        function (res) {
          let data = res.data
          this.smtp_project.project_name = data.project_name && data.project_name
          this.smtp_project.sender_alias = data.sender_alias && data.sender_alias
          this.smtp_project.sub_content = data.tail_content && data.tail_content
          this.smtp_project.page_size = data.pagination && data.pagination
          this.smtp_project.description = data.description && data.description
        }.bind(this)
      )
    },
    /**
     * Save SMTP Project
     */
    saveSMTPProject: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
        if (this.isEntityDisabled()) {
          return // Locked or expired entity will not able to perform these actions
        }
      }
      let data = {
        project_name: this.smtp_project.project_name,
        sender_alias: this.smtp_project.sender_alias,
        page_size: this.smtp_project.page_size,
        sub_content: this.smtp_project.sub_content,
        description: this.smtp_project.description,
        entity_id: entityId
      }
      this.isLoading = true
      this.PUSH_SMTP_PROJECT(data).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getEntitySmtpConfig()
          this.isLoading = false
        }.bind(this)
      ).catch(
        function (error) {
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    /**
     * Save SMTP Server
     */
    saveSMTPEmailServer: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
        if (this.isEntityDisabled()) {
          return // Locked or expired entity will not able to perform these actions
        }
      }
      let data = {
        smtp_domain: this.smtp_email.smtp_domain,
        smtp_sender: this.smtp_email.smtp_sender,
        // smtp_password: this.smtp_email.smtp_password,
        smtp_use_tls: this.smtp_email.smtp_use_tls,
        smtp_port: this.smtp_email.smtp_port,
        entity_id: entityId
      }
      this.isLoading = true
      this.PUSH_CONFIG_SMTP_EMAIL_SERVER(data).then(
        function () {
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getSMTPEmailServer()
        }.bind(this)
      ).catch(
        function (error) {
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    /**
     * Get SMTP Email server
     */
    getSMTPEmailServer: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
      }
      let filter = {
        params: {
          entityId: entityId
        }
      }
      this.GET_CONFIG_SMTP_EMAIL_SERVER(filter).then(
        function (res) {
          let data = res.data
          this.smtp_email.smtp_domain = data.smtp_domain && data.smtp_domain
          this.smtp_email.smtp_sender = data.smtp_sender && data.smtp_sender
          this.smtp_email.smtp_port = data.smtp_port && data.smtp_port
          this.smtp_email.smtp_use_tls = data.smtp_use_tls && data.smtp_use_tls
          this.smtp_email.smtp_password = null
        }.bind(this)
      )
    },
    getMailGatewayConfiguration: function () {
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
      }
      this.GET_ENTITY_MAIL_GATEWAY_CONFIGURATION({ id: entityId }).then(
        function (res) {
          let data = res.data
          this.mailGateway.apikey = data.mail_gateway_api_key
          this.mailGateway.baseUrl = data.mail_gateway_url
        }.bind(this)
      )
    },
    saveMailGatewayConfiguration: function () {
      let filter = {
        mailGatewayApiKey: this.mailGateway.apikey,
        mailGatewayURL: this.mailGateway.baseUrl
      }
      let entityId = this.entityId
      if (!this.isAdmin()) {
        entityId = sessionStorage.getItem('entityId')
        if (this.isEntityDisabled()) {
          return // Locked or expired entity will not able to perform these actions
        }
      }
      this.SET_ENTITY_MAIL_GATEWAY_CONFIGURATION({ id: entityId, ...filter }).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
        }.bind(this)
      ).catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    sendTestEmail: function () {
      this.$refs.sendTestEmail.onShowModal()
    },
    ...mapActions([
      'SET_USE_PRIVATE_SMTP',
      'GET_SMTP_PROJECT',
      'GET_ENTITY_SMTP_CONFIGURATION',
      'PUSH_SMTP_PROJECT',
      'GET_CONFIG_SMTP_EMAIL_SERVER',
      'PUSH_CONFIG_SMTP_EMAIL_SERVER',
      'PUSH_SMTP_EMAIL_PASSWORD',
      'SET_ENTITY_MAIL_GATEWAY_CONFIGURATION',
      'GET_ENTITY_MAIL_GATEWAY_CONFIGURATION',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
